import React from "react";

function ProgressBar({
  children,
  value = "0%",
  title = "Profile Registration",
}) {
  return (
    //     <div className="bg-beige p-1 rounded-[15px]">
    //       <div className="bg-white shadow-md rounded-[13px] p-4 flex flex-col gap-4 md:flex-row md:items-center">
    //         <h2 className="text-[20px] font-bold  text-black whitespace-nowrap md:text-[20px] text-left text-[15px]">
    //           {title}
    //         </h2>
    //         <ProgressBarBox value={value} />
    //         {children}

    //       </div>
    //       <div>
    // <p className="text-center text-black text-[15px] p-3 md:text-[12px] md:leading-[14px]">
    //         Register now to explore a range of tailored services just for you. Once
    //         registered, our funds access services will be available to meet your financial needs.
    //       </p>
    //       </div>

    //     </div>
    <div className="rounded-2xl bg-[#F8F3EB] p-1">
      <div className="bg-white rounded-2xl shadow-md p-4 md:p-6">

        {/* Header */}
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <h2 className="text-lg md:text-2xl font-bold text-black">
            {title}
          </h2>

          <div className="w-full lg:flex-1 lg:ml-6">
            <ProgressBarBox value={value} />
          </div>

          {children}
        </div>

        {/* Bottom Text */}
        <p className="mt-5 text-center text-gray-600 text-sm md:text-base leading-6">
          Register now to explore a range of tailored services just for you.
          Once registered, our funds access services will be available to meet
          your financial needs.
        </p>

      </div>
    </div>
  );
}

export default ProgressBar;

export function ProgressBarBox({ value }) {
  return (
    <div className="w-full bg-gray-200 rounded-[25px] overflow-hidden h-[25px] relative">
      <div
        className="progress-bar h-full text-center text-white font-bold whitespace-nowrap transition-all duration-500 ease-in-out bg-gradient-to-r from-orange-600 to-orange-300 rounded-[25px] shadow-inner hover:from-orange-500 hover:to-red-400 hover:shadow-lg text-[14px] leading-[25px] px-2"
        style={{ width: value }}
      >
        {value}
      </div>
    </div>
  );
}
